import SubtleBadge from '../../../../components/common/SubtleBadge';
import HelpTooltip from '../HelpTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type OrderStatusRendererProps = {
  status?: number | null;
};

export const OrderStatusRenderer = ({
  status
}: OrderStatusRendererProps) => {
  const statusEl = () => {
    switch (status) {
      case 0:
        return (
          <SubtleBadge
            pill
            bg="success"
            className="d-flex align-items-center justify-content-center gap-1 w-100 fs--2"
          >
            <FontAwesomeIcon icon="check" transform="shrink-2" />
            موفق
          </SubtleBadge>
        );
      case 2:
        return (
          <SubtleBadge
            pill
            bg="danger"
            className="d-flex align-items-center justify-content-center gap-1 w-100 fs--2"
          >
            <FontAwesomeIcon icon="ban" transform="shrink-2" />
            ناموفق
            <FontAwesomeIcon
              className="cursor-pointer"
              icon="exclamation-circle"
            />
          </SubtleBadge>
        );
      case 1:
        return (
          <SubtleBadge
            pill
            bg="warning"
            className="d-flex align-items-center justify-content-center gap-1 w-100 fs--2"
          >
            <FontAwesomeIcon icon="stream" transform="shrink-2" />
            درانتظار پرداخت
          </SubtleBadge>
        );

      case 3:
        return (
          <SubtleBadge
            pill
            bg="warning"
            className="d-flex align-items-center justify-content-center gap-1 w-100 fs--2"
          >
            <FontAwesomeIcon icon="stream" transform="shrink-2" />
            عودت وجه
          </SubtleBadge>
        );

      case 4:
        return (
          <SubtleBadge
            pill
            bg="warning"
            className="d-flex align-items-center justify-content-center gap-1 w-100 fs--2"
          >
            <FontAwesomeIcon icon="stream" transform="shrink-2" />
            پیش فاکتور
          </SubtleBadge>
        );

      default:
        return <></>;
    }
  };
  return (
    <div className="w-100 d-flex h-100 align-items-center justify-content-center ">
      {statusEl()}
    </div>
  );
};

type OrderFactorRendererProps = {
  status?: number | boolean | null;
  factor_status?: number | null;
  noShow?: boolean;
};

export const OrderFactorRenderer = ({
  status,
  factor_status,
  noShow
}: OrderFactorRendererProps) => {
  return status ? (
    <SubtleBadge
      pill
      bg="success"
      className="align-items-center justify-content-center gap-1 w-100 fs--2"
    >
      <FontAwesomeIcon icon="check" transform="shrink-2" />
      صادر شده
    </SubtleBadge>
  ) : !noShow ? (
    <SubtleBadge
      pill
      bg={
        factor_status === 0
          ? 'warning'
          : factor_status === 2
            ? 'danger'
            : 'info'
      }
      className="align-items-center justify-content-center gap-1 w-100 fs--2"
    >
      <FontAwesomeIcon icon="stream" transform="shrink-2" />
      {factor_status === 0
        ? 'در حال بررسی'
        : factor_status === 2
          ? 'عدم تایید'
          : 'در حال صدور'}
      <HelpTooltip
        html={
          'در صورت تایید اطلاعات، صدور و ارسال فاکتور به سامانه مودیان حداکثر تا آخر ماه صورت میگیرد.'
        }
      />
    </SubtleBadge>
  ) : null;
};
